<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3  v-if="driver" class="text-themecolor">{{ title }} for {{driver.name_first}} {{driver.name_last}}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol  v-if="driver" class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }} for {{driver.name_first}} {{driver.name_last}}</li>
            </ol>
        </div>
    </div>
    <div v-if="balance!=null" class="row">
      <div class="col-md-6 col-lg-3">
        <div class="card" >
            <div class="card-body">
                <div class="row p-t-10 p-b-10">
                    <!-- Column -->
                    <div class="col p-r-0">
                        <h1 class="font-light">${{(balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</h1>
                        <h6 class="text-muted">Your balance</h6></div>
                    <!-- Column -->
                </div>
            </div>
        </div>
      </div>
    </div>
    <div v-if="balance!=null" class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card" >
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Ride and Transaction Dashboard</h4>
              </div>
          </div>
          <div class="card-body">

            <div class="col-md-4 col-lg-4 m-0 p-0">
              <div class="m-3">
                <label class="search-label">Filter by Type</label>
                <select type="text" placeholder="Market"
                        class="form-control down" v-on:change="changeType($event)">
                  <option value="">
                    All
                  </option>
                  <option v-for="(item) in types" :value="item.id">
                    {{titleCase(item.code.replace(/_/g, " "))}}
                  </option>
                </select>
              </div>
            </div>

            <div class="result">
              <div class="">
                <div class="table-responsive">
                  <button @click="download()" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer; float:right;">Export</button>
                  <table class="table table-hover table-sm">
                    <tbody class="col-12">
                    <tr style="cursor: pointer">
                      <th class="result-label" width="150px">
                        <div class=""  @click="sort('date_transaction')">
                          Transaction Date
                          <div class="arrow-down" ref="date_transaction" :name="'date_transaction'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label" width="150px">
                        <div class=""  @click="sort('date_transaction')">
                          Trip Date
                          <div class="arrow-down" ref="date_transaction" :name="'date_transaction'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label" width="10%">
                        <div class="" @click="sort('id_type_transaction')">
                        Type
                        <div class="arrow-down" ref="id_type_transaction" :name="'id_type_transaction'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label"  width="8%">Status</th>
                      <th class="result-label" width="8%">
                        <div class="" @click="sort('id_ride')">
                          Trip ID
                          <div class="arrow-down" ref="id_ride" :name="'id_ride'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label" width="8%">
                        <div class=""  @click="sort('amount')">
                          Amount
                          <div class="arrow-down" ref="amount" :name="'amount'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div></th>
                      <th class="result-label"  width="8%">Balance</th>
                      <th class="result-label">Comment</th>
                    </tr>

                    <template v-for="tran in data">
                      <tr>
                        <td class="result-item">
                          {{ moment(tran.date_transaction).format("YYYY-MM-DD")  + " (" + moment.tz.guess() + ")" }}
                        </td>
                        <td class="result-item">
                          {{ tran.id_ride && tran.id_ride.date_pickup ? moment(tran.id_ride.date_pickup).format("YYYY-MM-DD")  + " (" + moment.tz.guess() + ")" : moment(tran.date_transaction).format("YYYY-MM-DD")  + " (" + moment.tz.guess() + ")" }}
                        </td>
                        <td class="result-item">
                          {{ tran.id_type_transaction ? titleCase(tran.id_type_transaction.code.replace(/_/g, " ")) : '' }}
                        </td>
                        <td class="result-item">
                          {{tran.id_type_transaction.id==1 ? (tran.date_processed ? 'Processed' : 'Scheduled') : 'N/A'}}
                        </td>
                        <td class="result-item">
                          <router-link v-if="tran.id_ride" :to="'/rides/' +tran.id_ride.id_ride + '/'">
                            {{ tran.id_ride.id_alternate ?  tran.id_ride.id_alternate : tran.id_ride.id_ride }}
                          </router-link>
                          {{ !tran.id_ride ? "N/A" : '' }}
                        </td>
                        <td class="result-item">
                          <!--{{ '$' + (["extra_payment", "transfer_to_bank", "payment_adjustment", "payment_reversal"].includes(tran.id_type_transaction.code) ? (tran.amount && tran.amount > 0 ? tran.amount.toFixed(2).replace(/\d(?=(\d{2})+\.)/g, '$&,') : 0) : tran.id_type_transaction.code!='penalty' && tran.id_ride ? (tran.id_ride.price_driver_revenue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')) : 0) }}-->
                          ${{ tran.amount ? tran.amount.toFixed(2) : '0.00' }}
                        </td>
                        <td class="result-item">
                          ${{ tran.balance ? tran.balance.toFixed(2) : '0.00' }}
                        </td>
                        <td class="result-item" style="padding: 0px 0.85rem;">
                          {{ tran.comment ? tran.comment : 'N/A'}}
                          <button v-if="tran.id_type_transaction.id==2" @click="tran.show_details=!tran.show_details" class="btn btn-info waves-effect waves-light m-t-10 m-b-5">Details</button>
                        </td>
                      </tr>
                      <tr v-if="tran.id_ride && tran.show_details" class="transaction-details" style="text-align: left">
                        <td colspan="7">
                          <table class="table table-striped table-bordered table-hover table-condensed">
                            <tbody><tr>
                              <th colspan="2">Booking Information</th>
                            </tr>
                            <tr>
                              <td>Pickup Address</td>
                              <td>{{tran.id_ride.default_pickup_address}}</td>
                            </tr>
                            <tr>
                              <td>Dropoff Address</td>
                              <td>{{tran.id_ride.default_dropoff_address}}</td>
                            </tr>
                            <tr>
                              <td>Distance</td>
                              <td>{{ tran.id_ride.default_distance_p_to_d ? (tran.id_ride.default_distance_p_to_d).toFixed(2) : 0 }} miles</td>
                            </tr>
                            <tr>
                              <td>Ride Duration</td>
                              <td>{{ tran.id_ride.default_duration_p_to_d ? (tran.id_ride.default_duration_p_to_d/60).toFixed(2) : 0 }} minutes</td>
                            </tr>
                            </tbody>
                          </table>
                          <table class="table table-striped table-bordered table-hover table-condensed">
                            <tbody><tr>
                              <th colspan="2">Transaction Details</th>
                            </tr>
                            <tr>
                              <td>Loaded Miles</td>
                              <!--<td>${{(tran.id_ride.price_total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</td>-->
                              <td>{{ tran.id_ride.price_driver_revenue ? ('$' + (tran.id_ride.price_driver_revenue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')) : 'N/A' }}</td>
                            </tr>
                            <!--<tr>-->
                              <!--<td colspan="2">General Platform Fees</td>-->
                            <!--</tr>-->
                            <!--<tr>-->
                              <!--<td>&nbsp;&nbsp;- Rate per Loaded Mile</td>-->
                              <!--<td>${{ tran.id_ride.price_insurance_fee ? tran.id_ride.price_insurance_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0 }}</td>-->
                            <!--</tr>-->
                            <tr v-if="tran.id_ride.price_additional" >
                              <td>Unloaded Miles</td>
                              <td>${{tran.id_ride.price_additional ? tran.id_ride.price_additional.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0 }}</td>
                            </tr>
                            <!--<tr>-->
                              <!--<td>&nbsp;&nbsp;- Rate per Unloaded Mile</td>-->
                              <!--<td>${{ tran.id_ride.price_insurance_fee ? tran.id_ride.price_insurance_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0 }}</td>-->
                            <!--</tr>-->
                            <tr>
                              <th>Total Driver Payout</th>
                              <td class="text-bold" style="font-weight: bold">${{ tran.id_ride.price_driver_revenue && tran.id_ride.price_additional ? (tran.id_ride.price_driver_revenue + tran.id_ride.price_additional).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : tran.id_ride.price_driver_revenue ? tran.id_ride.price_driver_revenue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0 }}</td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="!data || data.length==0">
                      <td colspan="6">
                        No data available
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>

                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Driver Dashboard',
    },
    name: 'DriverDashboard',
    data () {
      return {
        title: 'Driver Dashboard',
        data: {},
        id_driver: null,
        driver: null,
        balance: 0,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        with_deactivated: false,
        types: [],
        type_chose: null,
        prev_sort: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      sort(field) {
        // console.log(field)
        // let obj = this.$refs[field]
        // if (this.prev_sort) {
        //   this.prev_sort.style.visibility = 'hidden'
        // }
        //
        // let value = obj.getAttribute('value')
        // console.log(obj.getAttribute('name'))
        // obj.setAttribute('value', -value)
        // console.log(obj.getAttribute('value'))
        //
        // obj.style.visibility = 'visible'
        // obj.style.transform = "rotate("  + (value>0?0:1) * 180 +  "deg)"
        //
        // this.prev_sort = obj
        //
        // this.search()
      },
      changeType(event) {
        console.log(event.target.value)
        this.type_chose = event.target.value

        this.search()
      },
      download: function() {
        this.isLoading = true
        this.$http({
          url: process.env.API_BASE_URL_CS + 'download_driver_transaction/?id_user=' + this.id_driver,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'driver-dashboard-for-' + this.driver.name_first + '-' + this.driver.name_last + '.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.isLoading = false
        });
      },
      getTypes: function () {
        this.$http
          .get(process.env.API_BASE_URL_CS + 'type-transactions/?type=dashboard-types')
          .then(response => {
            console.log(response.data)
            this.types = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
          })
          .finally(() => {

          })
      },
      getBalance: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/' + this.id_driver + '/?type=balance')
          .then(response => {
            console.log(response.data)
            this.balance = response.data.balance

            this.search()
            this.getTypes()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {

          })
      },
      getUser: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/' + this.id_driver)
          .then(response => {
            console.log(response.data)
            this.driver = response.data

            this.getBalance()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {

          })
      },
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/?to_id_user=' + this.id_driver + '&pending=0'
            + '&page=' + (page ? page : this.currentPage)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '-date_approved')
            + (this.type_chose ? '&id_type_transaction=' + this.type_chose : ''))
          .then(response => {
            console.log(response.data)
            for (let index in response.data.results) {
              response.data.results[index]['show_details'] = false
            }
            this.data = response.data.results

            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        console.log('change to page: ' + page)
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      titleCase: function(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
      }
    },
    mounted () {
      this.id_driver = this.$route.params.id_driver
      this.getUser()
    },
    created () {
      // document.title = "Wingz Support | Driver Dashboard";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table td, .table th {
    vertical-align: middle;
    padding: .85rem;
  }

  .table td .btn {
    float: right;
    position: absolute;
    right: 25px;
    transform: translateY(-50%);
    padding: 3px 12px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-hover tbody tr.transaction-details:hover {
    background-color: transparent;
  }
  .table-hover tbody tr.transaction-details tr:hover {
    background-color: transparent;
  }
  tr.transaction-details .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #e9edf2;
  }
</style>



// WEBPACK FOOTER //
// src/components/DriverDashboard.vue